import styles from './Separador.module.css'


export default function Separador (){
  
  return(
    <div className={styles.separador}></div>
  )
}